import { useTranslation } from 'react-i18next';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { FilterGroup } from 'src/types/interfaces/filter-group';
import { Filters } from 'src/types/interfaces/filters';
import { toggleFilterItemSelection } from 'src/utils/filters/toggle-filter-item-selection';
import { ButtonSelect } from '../button-select';
import { SetStateAction } from 'react';
import { StatisticsVariant } from 'src/features/statistics/types/statistic-variant';
import { DateObject } from 'react-multi-date-picker';

interface Props {
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
  variant: StatisticsVariant;
  setVariant: React.Dispatch<SetStateAction<StatisticsVariant>>;
  setDateRange: React.Dispatch<SetStateAction<DateObject[] | null>>;
}

const items: {
  value: string;
  label: string;
  color?: string;
}[] = [];

const statisticVariantFilterGroup: FilterGroup<string> = {
  id: 3,
  type: 'variant',
  label: '',
  singleOption: true,
  filterOperator: 'custom',
  items,
};

export const StatisticVariantFilterSelect = ({
  filters,
  handleChangeFilterValue,
  variant,
  setVariant,
  setDateRange,
}: Props) => {
  const { t } = useTranslation();

  return (
    <ButtonSelect
      items={[
        {
          text: t('statistics:common.variant.monthly'),
          onClick: () => {
            toggleFilterItemSelection(
              statisticVariantFilterGroup.type,
              'MONTHLY',
              statisticVariantFilterGroup.singleOption,
              filters,
              handleChangeFilterValue,
              statisticVariantFilterGroup.filterOperator,
            );
            setVariant('MONTHLY');
            setDateRange(null);
          },
        },
        {
          text: t('statistics:common.variant.daily'),
          onClick: () => {
            toggleFilterItemSelection(
              statisticVariantFilterGroup.type,
              'DAILY',
              statisticVariantFilterGroup.singleOption,
              filters,
              handleChangeFilterValue,
              statisticVariantFilterGroup.filterOperator,
            );
            setVariant(prev => (prev === 'MONTHLY' ? 'DAILY' : 'MONTHLY'));
            setDateRange(null);
          },
        },
      ]}
      variant="outlinedContained"
      size="large"
      sx={{
        color: 'text.primary',
        fontWeight: '400',
        mr: 2,
      }}>
      {t(`statistics:common.variant.${variant.toLowerCase()}`)}
    </ButtonSelect>
  );
};
